export const ACCESS_LOGS_SEARCH_PARAM_GATE_ID = 'gateId';
